<template>
    <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>
    <button class="returnBtn" @click="back">返回</button>
     <div class="mt-2 container bg-white" v-if="!isLoading">
     <p v-show="error">{{ error }}</p>   
   
      <div v-if="!isLoading">

      <div>
          <div class="mt-1 d-flex flex-column bg-white m-1 p-1 pt-3">
            
           

          
          

            <div class="mt-1 d-flex justify-content">
              cookie： <div class="flex-fill"><textarea v-model="cookie" rows="20" style="width: 100%;"></textarea></div>
            </div>

           
            <div>

            </div>
              
          </div>

        </div>
        

         </div>
         <div class="d-flex justify-content-center p-1">
          <button class="btn normalBtn" @click="set()">保存</button>
         </div>
        
     </div>

   </template>
   
   <script>
   
   import GridLoader from 'vue-spinner/src/GridLoader.vue'
   import axios from 'axios';


   export default {
     data(){
       return {
         isLoading:false,
         error:'',
         spinnerColor:"#262626",
         cookie:null,
         account_id:null
         
       }
       
     },
  
   
     components: {
      GridLoader
     
     },
      setup(){
        var token=localStorage.getItem('sessionToken')
        axios.defaults.headers.common['X-Parse-Session-Token'] = token
        
     },
   
   
     mounted(){
      var token=localStorage.getItem('sessionToken')
       
          if(token==undefined || token==null ||token=='')
        {
          this.$router.push('/')
          return
        }
        axios.defaults.headers.common['X-Parse-Session-Token'] = token
        this.account_id=this.$route.params.id
      

     },
     methods:{
      async set(){
        try{
            
          console.log(this.cookie)
            this.isLoading=true
            const response = await axios.post(this.domain+'xhs/add_ck',
            {
              'account_id':this.account_id,
            'cookie':this.cookie
          });

            var data=response.data
            console.log(data)
            if(data.status=='Suc')
            {
                 this.$router.go(-1)
                
            }
            else
            {
              this.error=data
            }
        }
        catch(error)
        {
            console.error(data)
        }
        finally
        {
            this.isLoading=false
        }

      },

      
      back(){
        this.$router.go(-1)
      }
     
      

       
     }
      
     
   };
   </script>
<style scoped>
.green_border{
    border:0.0375 solid green;
}
.account_icon{
  width: 0.35rem;
height: 0.35rem;
border-radius: 0.35rem;
}
.img{
    width:3.5rem;
    border-radius: 0.125rem 0 0 0.125rem;
}
.card{
  background: white;
  border-radius: 0.125rem;
  width:30%;
  height:2rem;
}
.cardRight{
  height:2rem;
}
.cardText{
  color: #262626;
 font-family: "Alibaba PuHuiTi";
 font-size: 0.175rem;
 font-style: normal;
 font-weight: 500;
 text-align: left;
}
.icon{
  width:0.175rem;
  height:0.175rem;
}

.pageBox{
  width: 0.3125rem;
  height:0.3125rem;
  border-radius: 0.125rem;
  cursor:pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  
 font-family: "Alibaba PuHuiTi";
 font-size: 0.175rem;
 font-style: normal;
 font-weight: 500;
}
.normalPage{
  background: white;
  color: #262626;
}

.selectedPageBox
{
  background: #3b64ff;
  color:white
}

</style>
   